<style lang="scss" scoped>
@import '../../../sass/utilities/variables';

  .row-1 {
    display: flex;
    justify-content: space-between;
  }

  .row-2 {
    display: flex;
    gap: 4rem;
    padding: 1.5rem 0;
  }

  .job-container {
    padding: 3rem;
    display: flex;
    justify-content: space-between;
    border: 1px solid $light-silver;
    margin-top: 3rem;
    border-radius: 2rem;
  }

  .view-job-button {
    width: 20rem;
    text-align: center;
  }

  .job-title {
    font-weight: bold;
    font-style: normal;
    font-size: 2rem;
    color: $dark-grey;
  }

  .job-details {
    font-weight: bold;
    font-style: normal;
    font-size: 1.4rem;
    color: $dark-grey;
  }

  .post-date {
    font-weight: 400;
    font-style: normal;
    font-size: 1.3rem;
    color: $ironside-grey;
  }
</style>
<template>
  <div class="job-container">
    <div>
      <div class="row-1">
        <div class="job-title">{{ data.item.title }}</div>
      </div>
      <div class="row-2">
        <div class="job-details">
          {{ data.item.jobLocation.address.addressLocality
          + ", "
          + data.item.jobLocation.address.addressRegion }}
        </div>
        <div class="job-details">{{ employmentType }}</div>
        <div>
          <div
            v-if="hasSalary"
            class="job-details"
          >
            {{ formattedSalary}}
          </div>
        </div>
      </div>
      <div>
        <div class="post-date">{{ postedText }}</div>
      </div>
    </div>
    <div>
      <a
        class="button view-job-button"
        ref="jobButton"
        :href="data.item.url"
        target="_blank"
      >
        View Job
      </a>
    </div>
  </div>
</template>
<script>
import dateFactory, { duration as createDuration } from '../../../js/date';

import dynamicTextColor from '../../../js/dynamicTextColor';

export default {
  mounted() {
    if (this.hasCustomColor) {
      this.$refs.jobButton.style.backgroundColor = this.hexColor;
      this.$refs.jobButton.style.color = this.textColor;
    }
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
    hexColor: {
      type: String,
      default: '',
    },
  },

  computed: {
    hasSalary() {
      if (typeof this.data.item.baseSalary === 'undefined') {
        return false;
      }

      return this.data.item.baseSalary.value.minValue > 0
        && this.data.item.baseSalary.value.maxValue > 0;
    },

    formattedSalary() {
      const salaryItem = this.data.item.baseSalary.value;
      const formattedSalaryType = salaryItem.unitText.charAt(0) + salaryItem.unitText.slice(1).toLowerCase();

      if (salaryItem.unitText === 'HOUR') {
        return `$${salaryItem.minValue.toFixed(2)} – $${salaryItem.maxValue.toFixed(2)} / ${formattedSalaryType}`;
      }
      const formattedMinimumSalary = (Number(salaryItem.minValue)).toLocaleString('en-US', { maximumFractionDigits: 0 });
      const formattedMaximumSalary = (Number(salaryItem.maxValue)).toLocaleString('en-US', { maximumFractionDigits: 0 });

      return `$${formattedMinimumSalary} – $${formattedMaximumSalary} / ${formattedSalaryType}`;
    },

    hasCustomColor() {
      return this.hexColor !== '' && this.hexColor !== null;
    },

    textColor() {
      return dynamicTextColor(this.hexColor);
    },

    postedText() {
      const now = dateFactory();
      const postDate = dateFactory(this.data.item.datePosted);
      const elapsed = createDuration(now.diff(postDate));

      if (elapsed.asHours() < 24) {
        return 'Posted in the last 24 hours';
      }

      if (elapsed.asDays() < 7) {
        return 'Posted in the last 7 days';
      }

      return 'Posted more than a week ago';
    },

    employmentType() {
      return this.data.item.employmentType === 'fulltime' ? 'Full Time' : 'Part Time';
    },
  },
};
</script>
